import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { MissingVm, confirmVmDeletion, syncVms } from "../service/sync.service";

export const useVmSync = (onSynced: () => void) => {
    const [syncLoading, setSyncLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [missingVms, setMissingVms] = useState<MissingVm[]>([]);

    const sync = useCallback(async () => {
        setSyncLoading(true);
        try {
            const result = await syncVms();
            setMissingVms(result.requires_deletion_confirmation ? result.missing_vms : []);
            onSynced();
        } catch (error) {
            console.error(error);
            toast.error("Não foi possível sincronizar com o vCenter.");
        } finally {
            setSyncLoading(false);
        }
    }, [onSynced]);

    const confirmDeletion = useCallback(async (serverIds: string[]) => {
        setIsDeleting(true);
        try {
            const result = await confirmVmDeletion(serverIds);
            setMissingVms([]);
            toast.success(`${result.deleted_vm_ids.length} máquina(s) removida(s) do painel.`);
            onSynced();
        } catch (error: any) {
            console.error(error);
            if (error?.response?.status === 409) {
                setMissingVms([]);
                toast.warning(
                    error.response.data?.detail ??
                    "Inventário do vCenter incompleto; nenhuma VM foi excluída."
                );
                return;
            }
            toast.error("Não foi possível excluir as máquinas selecionadas.");
        } finally {
            setIsDeleting(false);
        }
    }, [onSynced]);

    const cancelDeletion = useCallback(() => setMissingVms([]), []);

    return { sync, syncLoading, missingVms, isDeleting, confirmDeletion, cancelDeletion };
};
